export const API_VERSION = 'application/vnd.cfsc-opec.v4+json';
